import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const MainFaculties = () => {
  const { getText, LANGUAGES, currentLanguage } = useLanguage();

  // Senior Leadership - Head Position (4 Senior Monks)
  const seniorLeadership = [
    {
      name: {
        [LANGUAGES.EN]: 'Venerable Bhaddanta Kavinandha Mahathera',
        [LANGUAGES.MM]: 'ဘဒ္ဒန္တကဝိနန္ဒမဟာထေရ်'
      },
      title: {
        [LANGUAGES.EN]: 'University Chancellor',
        [LANGUAGES.MM]: 'တက္ကသိုလ်အဓိပတိဆရာတော်'
      },
      credentials: {
        [LANGUAGES.EN]: 'A master of monastic discipline, a scholar of Buddhist scriptures',
        [LANGUAGES.MM]: 'ဝိနည်းဂရုက၊ ပရိယတ္တိပညာရှင်'
      },
      gradient: 'leadership-gradient-1'
    },
    {
      name: {
        [LANGUAGES.EN]: 'Venerable Dr. Bhaddanta Paṇḍita',
        [LANGUAGES.MM]: 'ဒေါက်တာဘဒ္ဒန္တပဏ္ဍိတ'
      },
      title: {
        [LANGUAGES.EN]: 'Patron Sayadaw of the University Central Administration Board',
        [LANGUAGES.MM]: 'တက္ကသိုလ်အုပ်ချုပ်ရေးဗဟိုအဖွဲ့ နာယကဆရာတော်'
      },
      credentials: {
        [LANGUAGES.EN]: 'Ph.D (UK)',
        [LANGUAGES.MM]: 'Ph.D(UK)'
      },
      gradient: 'leadership-gradient-2'
    },
    {
      name: {
        [LANGUAGES.EN]: 'Venerable Dr. Bhaddanta Nanda Senalankara',
        [LANGUAGES.MM]: 'ဒေါက်တာဘဒ္ဒန္တနန္ဒသေနာလင်္ကာရ'
      },
      title: {
        [LANGUAGES.EN]: 'University Rector',
        [LANGUAGES.MM]: 'တက္ကသိုလ်ပါမောက္ခချုပ်ဆရာတော်'
      },
      credentials: {
        [LANGUAGES.EN]: 'Ph.D, Dhamma Paraguru Degree',
        [LANGUAGES.MM]: 'Ph.D ဓမ္မပါရဂူဘွဲ့'
      },
      gradient: 'leadership-gradient-3'
    },
    {
      name: {
        [LANGUAGES.EN]: 'Venerable Bhaddanta Vijjānanda',
        [LANGUAGES.MM]: 'ဘဒ္ဒန္တဝိဇ္ဇာနန္ဒ'
      },
      title: {
        [LANGUAGES.EN]: 'Chairman of Central Administrative Board',
        [LANGUAGES.MM]: 'တက္ကသိုလ်အုပ်ချုပ်ရေးဗဟိုအဖွဲ့ ဥက္ကဋ္ဌဆရာတော်'
      },
      credentials: {
        [LANGUAGES.EN]: 'Senior Administrative Leader',
        [LANGUAGES.MM]: 'အုပ်ချုပ်ရေးဆိုင်ရာ ဦးဆောင်ဆရာတော်'
      },
      gradient: 'leadership-gradient-4'
    }
  ];

  // Deputy Vice-Chancellors
  const deputyViceChancellors = [
    {
      name: {
        [LANGUAGES.EN]: 'Dr. Aye Chan',
        [LANGUAGES.MM]: 'ဒေါက်တာအေးချမ်း'
      },
      title: {
        [LANGUAGES.EN]: 'Deputy Vice-Chancellor (Academic Affairs)',
        [LANGUAGES.MM]: 'သင်ကြားရေးဆိုင်ရာ ဒုတိယပါမောက္ခချုပ်'
      },
      gradient: 'leadership-gradient-5'
    },
    {
      name: {
        [LANGUAGES.EN]: 'Dr. Han Win',
        [LANGUAGES.MM]: 'ဒေါက်တာဟံဝင်း'
      },
      title: {
        [LANGUAGES.EN]: 'Deputy Vice-Chancellor (Academic Affairs)',
        [LANGUAGES.MM]: 'သင်ကြားရေးဆိုင်ရာ ဒုတိယပါမောက္ခချုပ်'
      },
      gradient: 'leadership-gradient-6'
    },
    {
      name: {
        [LANGUAGES.EN]: 'Dr. Zaw Min Aung',
        [LANGUAGES.MM]: 'ဒေါက်တာဇော်မင်းအောင်'
      },
      title: {
        [LANGUAGES.EN]: 'Deputy Vice-Chancellor (Administrative Affairs)',
        [LANGUAGES.MM]: 'စီမံရေးဆိုင်ရာ ဒုတိယပါမောက္ခချုပ်'
      },
      gradient: 'leadership-gradient-7'
    }
  ];

  // University Objectives
  const objectives = [
    {
      icon: '🎓',
      title: {
        [LANGUAGES.EN]: 'Academic Excellence',
        [LANGUAGES.MM]: 'ပညာရေးထူးချွန်မှု'
      },
      description: {
        [LANGUAGES.EN]: 'To establish a comprehensive academic environment where the teachings of the Tipitaka and modern missionary methods are rigorously studied, taught, and disseminated with English as the Medium of Instruction.',
        [LANGUAGES.MM]: 'ပိဋကကို မဏ္ဍိုင်ပြုပြီး ခေတ်မီ သာသနာပြုနည်းပညာတို့ကို (အင်္ဂလိပ်စာကို သင်ကြားမှုမဏ္ဍိုင်- Medium of Instruction အဖြစ်ထားရှိလျက်) လေ့လာသင်ကြား ဖြန့်ဖြူးမှုကို အားပေးသော ပညာဝန်းကျင်(ဝါ)ပညာရပ်ဝန်းတစ်ခု ပီပြင်စွာပေါ်ထွန်းလာစေရန်။'
      }
    },
    {
      icon: '🌍',
      title: {
        [LANGUAGES.EN]: 'Global Scholarship Platform',
        [LANGUAGES.MM]: 'နိုင်ငံတကာ ပညာရှင်များ စုဝေးရာ'
      },
      description: {
        [LANGUAGES.EN]: 'To create a powerful platform for gathering distinguished scholars and experts, both local and international.',
        [LANGUAGES.MM]: 'ပြည်တွင်းပြည်ပမှ တော်သော်၊ကောင်းသော် ဆရာများ၏ စုဝေးရာနေရာ ဘူမိနက်သန် ဖြစ်လာစေရန်။'
      }
    },
    {
      icon: '👥',
      title: {
        [LANGUAGES.EN]: 'Community Welfare',
        [LANGUAGES.MM]: 'အသိုင်းအဝိုင်း ကောင်းကျိုး'
      },
      description: {
        [LANGUAGES.EN]: 'To foster the well-being of both the monastic students and the faculty.',
        [LANGUAGES.MM]: 'စာသင်သားသံဃာတော်များနှင့် ဆရာများ ချမ်းသာစေရန်။'
      }
    },
    {
      icon: '❤️',
      title: {
        [LANGUAGES.EN]: 'True Dhamma Vinaya University',
        [LANGUAGES.MM]: 'စစ်မှန်သော ဓမ္မဝိနယတက္ကသိုလ်'
      },
      description: {
        [LANGUAGES.EN]: 'To develop into a true and exemplary Dhamma Vinaya University, capable of fulfilling the noble aspirations of learned scholars and venerable individuals.',
        [LANGUAGES.MM]: 'အထူးသဖြင့် ပညာရှိသူတော်ကောင်းတို့ ၏ စိတ်တော်ကို ကျေနပ်စေနိုင်သော တကယ့် ဓမ္မဝိနယတက္ကသိုလ်ကြီးတစ်ခု ဖြစ်ထွန်းလာစေရန်။'
      }
    }
  ];

  return (
    <div className="main-faculties-page">
      {/* Banner Section */}
      <div className="page-banner main-faculties-banner">
        <div className="container">
          <div className="banner-content">
            <h1 className={`banner-title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'University Board',
                [LANGUAGES.MM]: 'မဟာနာယကဆရာတော်များ'
              })}
            </h1>
            <p className={`banner-subtitle ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Guided by wisdom and compassion, our distinguished leaders shape the future of Buddhist education',
                [LANGUAGES.MM]: 'ပညာနှင့် ကရုဏာတရားဖြင့် လမ်းညွှန်ကာ ဗုဒ္ဓပညာရေး၏ အနာဂတ်ကို ပုံသွင်းကြသော ကျွန်ုပ်တို့၏ ထင်ရှားသော ခေါင်းဆောင်များ'
              })}
            </p>
          </div>
        </div>
      </div>

      {/* University Structure Introduction */}
      <section className="main-faculties-intro section-padding">
        <div className="container">
          <div className="main-faculties-intro__content">
            <h2 className={`main-faculties-intro__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'University Structure',
                [LANGUAGES.MM]: 'တက္ကသိုလ် ဖွဲ့စည်းပုံ'
              })}
            </h2>
            <p className={`main-faculties-intro__text ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'This university is structured like a human body with three main parts. In the position of the head are four senior monks who guide the institution with wisdom and dedication.',
                [LANGUAGES.MM]: 'ဤတက္ကသိုလ်ကို လူတစ်ဦး၏ ကိုယ်ခန္ဓာကဲ့သို့ အစိတ်အပိုင်း (၃) ခုဖြင့် ပေါင်းစပ်တည်ဆောက်ထား ကြပေသည်။ ဦးခေါင်းပိုင်းနေရာတွင် ဆရာတော်ဘုရား (၄) ပါးရှိလေသည်။'
              })}
            </p>
          </div>
        </div>
      </section>

      {/* Senior Leadership - The Head */}
      <section className="main-faculties-senior section-padding">
        <div className="container">
          <div className="main-faculties-section__header">
            <h2 className={`main-faculties-section__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Senior Leadership Council',
                [LANGUAGES.MM]: 'အကြီးအကဲ ဆရာတော်များ'
              })}
            </h2>
            <p className={`main-faculties-section__subtitle ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'The Four Distinguished Monks - The Head of Our Institution',
                [LANGUAGES.MM]: 'ဦးခေါင်းပိုင်းနေရာမှ ဆရာတော်ဘုရား (၄) ပါး'
              })}
            </p>
          </div>

          <div className="main-faculties-grid main-faculties-grid--senior">
            {seniorLeadership.map((leader, index) => (
              <div key={index} className="main-faculties-card main-faculties-card--senior">
                <div className={`main-faculties-card__header ${leader.gradient}`}>
                  <div className="main-faculties-card__number">
                    <span>{index + 1}</span>
                  </div>
                  <h3 className={`main-faculties-card__name ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                    {getText(leader.name)}
                  </h3>
                </div>
                <div className="main-faculties-card__content">
                  <p className={`main-faculties-card__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                    {getText(leader.title)}
                  </p>
                  <p className={`main-faculties-card__credentials ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                    {getText(leader.credentials)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Deputy Vice-Chancellors Section */}
      <section className="main-faculties-deputy section-padding">
        <div className="container">
          <div className="main-faculties-section__header">
            <h2 className={`main-faculties-section__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Deputy Vice-Chancellors',
                [LANGUAGES.MM]: 'ဒုတိယပါမောက္ခချုပ်များ'
              })}
            </h2>
            <p className={`main-faculties-section__subtitle ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Supporting the senior leadership with expertise in academic and administrative affairs',
                [LANGUAGES.MM]: 'ပညာရေးနှင့် စီမံအုပ်ချုပ်ရေးဆိုင်ရာ ကျွမ်းကျင်မှုဖြင့် အကြီးအကဲများကို ပံ့ပိုးကူညီကြသူများ'
              })}
            </p>
          </div>

          <div className="main-faculties-grid main-faculties-grid--deputy">
            {deputyViceChancellors.map((leader, index) => (
              <div key={index} className="main-faculties-card main-faculties-card--deputy">
                <div className={`main-faculties-card__header ${leader.gradient}`}>
                  <div className="main-faculties-card__icon">
                    <span>👥</span>
                  </div>
                </div>
                <div className="main-faculties-card__content">
                  <h3 className={`main-faculties-card__name ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                    {getText(leader.name)}
                  </h3>
                  <p className={`main-faculties-card__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                    {getText(leader.title)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* University Objectives */}
      <section className="main-faculties-objectives section-padding">
        <div className="container">
          <div className="main-faculties-section__header">
            <h2 className={`main-faculties-section__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'University Objectives',
                [LANGUAGES.MM]: 'တက္ကသိုလ်၏ ရည်မှန်းချက်များ'
              })}
            </h2>
            <p className={`main-faculties-section__subtitle ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Our mission is guided by four fundamental objectives that shape our educational philosophy and institutional direction',
                [LANGUAGES.MM]: 'ကျွန်ုပ်တို့၏ ပညာရေးအတွေးအခေါ်နှင့် အဖွဲ့အစည်း၏ ဦးတည်ချက်ကို ပုံသွင်းသော အခြေခံရည်မှန်းချက် လေးခုဖြင့် လမ်းညွှန်ထားပါသည်'
              })}
            </p>
          </div>

          <div className="objectives-grid">
            {objectives.map((objective, index) => (
              <div key={index} className="objective-card">
                <div className="objective-card__icon">
                  <span>{objective.icon}</span>
                </div>
                <div className="objective-card__content">
                  <h3 className={`objective-card__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                    {getText(objective.title)}
                  </h3>
                  <p className={`objective-card__description ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                    {getText(objective.description)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      { /*
      Call to Action 
      <section className="main-faculties-cta">
        <div className="container">
          <div className="main-faculties-cta__content">
            <h2 className={`main-faculties-cta__title ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Join Our Academic Community',
                [LANGUAGES.MM]: 'ကျွန်ုပ်တို့၏ ပညာရေးအသိုင်းအဝိုင်းသို့ ပါဝင်ပါ'
              })}
            </h2>
            <p className={`main-faculties-cta__text ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Under the guidance of our distinguished leadership, embark on a journey of Buddhist learning and spiritual growth',
                [LANGUAGES.MM]: 'ကျွန်ုပ်တို့၏ ထင်ရှားသော ခေါင်းဆောင်များ၏ လမ်းညွှန်မှုအောက်တွင် ဗုဒ္ဓပညာသင်ယူခြင်းနှင့် ဝိညာဏ်ရေးရာ ကြီးထွားမှု၏ ခရီးစဉ်ကို စတင်ပါ'
              })}
            </p>
            <div className="main-faculties-cta__buttons">
              <button className={`btn-primary ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                {getText({
                  [LANGUAGES.EN]: 'Learn More About Admission',
                  [LANGUAGES.MM]: 'ဝင်ခွင့်အကြောင်း ပိုမိုလေ့လာရန်'
                })}
              </button>
              <button className={`btn-secondary ${currentLanguage === LANGUAGES.MM ? 'myanmar-text' : ''}`}>
                {getText({
                  [LANGUAGES.EN]: 'Contact Us',
                  [LANGUAGES.MM]: 'ဆက်သွယ်ရန်'
                })}
              </button>
            </div>
          </div>
        </div>
      </section>
      */}
    </div>
  );
};

export default MainFaculties;